export default __webpack_public_path__ + "assets/siliconValley.226f159b.png";